import {
    SET_ONLINE_TEXT,
    SET_OFFLINE_TEXT,
    SET_VIP_TEXT,
    SET_UNKNOWN_TEXT,
    SET_STATUSTEXTS,
} from './constants'

export function setOnlineText(text) {
    return {
        type: SET_ONLINE_TEXT,
        payload: text,
    }
}

export function setOfflineText(text) {
    return {
        type: SET_OFFLINE_TEXT,
        payload: text,
    }
}

export function setVipText(text) {
    return {
        type: SET_VIP_TEXT,
        payload: text,
    }
}

export function setUnknownText(text) {
    return {
        type: SET_UNKNOWN_TEXT,
        payload: text,
    }
}

export function setStatusTexts(texts) {
    return {
        type: SET_STATUSTEXTS,
        payload: texts,
    }
}



// WEBPACK FOOTER //
// ./src/features/ServerMenu/data/statusTexts/actions.js